export const INVITATION_TICKET_PARAM = "__clerk_ticket";
export const INVITATION_STATUS_PARAM = "__clerk_status";
export const LEGACY_INVITATION_TOKEN_PARAM = "__clerk_invitation_token";
export const FROM_INVITATION_PARAM = "from_invitation";

export type InvitationTicketStatus = "sign_in" | "sign_up" | "complete";

export interface InvitationUrlParams {
  ticket: string | null;
  status: InvitationTicketStatus | null;
  hasInvitationContext: boolean;
}

function readStatus(value: string | null): InvitationTicketStatus | null {
  if (value === "sign_in" || value === "sign_up" || value === "complete") {
    return value;
  }
  return null;
}

/** Read Clerk organisation-invitation query params from the current URL. */
export function readInvitationParams(search = window.location.search): InvitationUrlParams {
  const params = new URLSearchParams(search);
  const ticket =
    params.get(INVITATION_TICKET_PARAM) ?? params.get(LEGACY_INVITATION_TOKEN_PARAM);
  const status = readStatus(params.get(INVITATION_STATUS_PARAM));
  const hasInvitationContext = Boolean(
    ticket || params.get(FROM_INVITATION_PARAM) === "true",
  );

  return { ticket, status, hasInvitationContext };
}

/** Preserve invitation params when navigating between auth pages. */
export function buildInvitationSearch(
  sourceSearch = window.location.search,
  extraParams?: Record<string, string>,
): string {
  const source = new URLSearchParams(sourceSearch);
  const next = new URLSearchParams();

  const ticket =
    source.get(INVITATION_TICKET_PARAM) ?? source.get(LEGACY_INVITATION_TOKEN_PARAM);
  if (ticket) {
    next.set(INVITATION_TICKET_PARAM, ticket);
  }

  const status = source.get(INVITATION_STATUS_PARAM);
  if (status) {
    next.set(INVITATION_STATUS_PARAM, status);
  }

  if (source.get(FROM_INVITATION_PARAM) === "true") {
    next.set(FROM_INVITATION_PARAM, "true");
  }

  if (extraParams) {
    for (const [key, value] of Object.entries(extraParams)) {
      next.set(key, value);
    }
  }

  const qs = next.toString();
  return qs ? `?${qs}` : "";
}

export function appendInvitationSearch(path: string, search = buildInvitationSearch()): string {
  if (!search) return path;
  return `${path}${search}`;
}
